import { AppearanceComponent } from './../components/appearance/appearance.component';

export const appearanceRoutes = {
    path: 'appearance',
    component: AppearanceComponent,
    data: {
        breadcrumbs: {
            label: 'Vzhled',
            icon: 'dashboard'
        },
        state: 'appearance'
    },
    children: []
};
